import Vue from "vue";
import VueRouter from "vue-router";
import axios from "../plugins/axios";
import { i18n } from "../plugins/vue-i18n";

import Main from "../pages/client/Main.vue";

// import { BoardRoutes } from "./board.router";
// import { QuestionRoutes } from "./question.router";

Vue.use(VueRouter);

const routes = [
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 사용자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // Main 페이지
        path: "/",
        component: Main,
    },

    {
        // 변변변성범죄센터 - 대표변호사 소개
        path: "/rev/intro",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/rev/RevIntroPage.vue"),
        props: true,
    },
    {
        // 변변변성범죄센터 - 변변변 성범죄 센터 소개
        path: "/rev/about",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/rev/RevAboutPage.vue"),
        props: true,
    },
    
    {
        // 구성원 소개 - 변호사 소개
        path: "/member/lawyer",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/member/MemberLawyerPage.vue"),
        props: true,
    },
    {
        // 구성원 소개 - 자문단 소개
        path: "/member/advisory",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/member/MemberAdvisoryPage.vue"),
        props: true,
    },
    {
        // 구성원 소개 - 상세
        path: "/member/:_lawyer",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/member/MemberViewPage.vue"),
        props: true,
    },
    
    {
        // 이혼센터 성공사례 - 리스트
        path: "/story/firm",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/story/StoryFirmListPage.vue"),
        props: true,
    },
    {
        // 전체 성공사례 - 리스트
        path: "/story/representative",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/story/StoryRepresentativeListPage.vue"),
        props: true,
    },
    {
        // 성공사례 - 상세
        path: "/story/:_success",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/story/StoryViewPage.vue"),
        props: true,
    },
    {
        // 언론&미디어 - 인사이트 - 리스트
        path: "/insight_media/insight",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/insight/InsightListPage.vue"),
        props: true,
    },
    {
        // 언론&미디어 - 인사이트 - 상세
        path: "/insight_media/insight/:_insight",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/insight/InsightViewPage.vue"),
        props: true,
    },
    {
        // 언론&미디어 - 미디어 - 리스트
        path: "/insight_media/media",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/media/MediaListPage.vue"),
        props: true,
    },
    {
        // 언론&미디어 - 칼럼 - 리스트
        path: "/insight_media/column",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/column/ColumnListPage.vue"),
        props: true,
    }, 
    {
        // 언론&미디어 - 칼럼 - 상세
        path: "/insight_media/column/:_column",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/column/ColumnViewPage.vue"),
        props: true,
    }, 
    {
        // 언론&미디어 - 칼럼 - 리스트
        path: "/insight_media/review",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/review/ReviewListPage.vue"),
        props: true,
    }, 
    {
        // 언론&미디어 - 칼럼 - 상세
        path: "/insight_media/review/:_review",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/review/ReviewViewPage.vue"),
        props: true,
    }, 
    {
        // 언론&미디어 - 미디어 - 상세
        path: "/insight_media/media/media01",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/media/MediaViewPage.vue"),
        props: true,
    }, 
    
    {
        // 담당업무
        path: "/business/:code",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/business/BusinessPage.vue"),
        props: true,
    },
    
    {
        // 심리안정프로그램
        path: "/program",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/program/ProgramPage.vue"),
        props: true,
    },
    
    {
        // 오시는 길
        path: "/contact",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/contact/ContactPage.vue"),
        props: true,
    },

    {
        // 가이드
        path: "/guide",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/guide/guide-app.vue"),
        props: true,
    },
    {
        // 예시페이지
        path: "/ex",
        component: () => import(/* webpackChunkName: "guide" */ "../pages/client/sub/example-page.vue"),
        props: true,
    },


    // 게시판
    {
        // FAQ
        path: "/center/faqs",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/faq.vue"),
        props: true,
    },
    {
        // 공지사항
        path: "/center/notice",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
        props: true,
    },
    {
        // 공지사항
        path: "/center/notice/:_notification",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/center/notice.vue"),
        props: true,
    },
    {
        // 기본게시판
        path: "/board/default-board",
        component: () => import(/* webpackChunkName: "center" */ "../pages/client/board/default-board.vue"),
        props: true,
    },

    // 폼메일
    {
        // 기본폼
        path: "/default-form",
        component: () => import(/* webpackChunkName: "form" */ "../pages/client/form/default-form.vue"),
        props: true,
    },

    // 개인정보처리방침
    {
        // 개인정보처리방침
        path: "/privacy-policy",
        component: () => import(/* webpackChunkName: "sub" */ "../pages/client/center/privacy-policy.vue"),
        props: true,
    },

    // kcp
    // {
    //     path: "/common/kcp/cert/request",
    //     component: () => import("../pages/common/kcp/KCPCertRequest.vue"),
    //     props: true,
    // },
    // {
    //     path: "/common/kcp/cert/response",
    //     component: () => import("../pages/common/kcp/KCPCertResponse.vue"),
    //     props: true,
    // },

    // 로그인/회원가입
    // {
    //     // 로그인
    //     path: "/login",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/main.vue"),
    //     props: true,
    // },
    // {
    //     // 비밀번호 찾기
    //     path: "/login/find-password",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-password.vue"),
    //     props: true,
    // },
    // {
    //     // 아이디 찾기
    //     path: "/login/find-id",
    //     component: () => import(/* webpackChunkName: "login" */ "../pages/client/login/find-id.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입
    //     path: "/join",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/main.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 폼
    //     path: "/join/type",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/type.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 폼
    //     path: "/join/form",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/form.vue"),
    //     props: true,
    // },
    // {
    //     // 회원가입 완료
    //     path: "/join/complete",
    //     component: () => import(/* webpackChunkName: "join" */ "../pages/client/join/complete.vue"),
    //     props: true,
    // },

    // 마이페이지
    // {
    //     // 1:1 문의
    //     path: "/mypage/question",
    //     component: () => import(/* webpackChunkName: "question" */ "../pages/client/mypage/question.vue"),
    //     children: [...QuestionRoutes],
    //     props: true,
    // },
    // {
    //     // 회원 정보 상세
    //     path: "/mypage/myinfo",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/myinfo.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 정보 변경
    //     path: "/mypage/myinfo/:tab",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/myinfo.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 탈퇴
    //     path: "/mypage/leave",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/leave.vue"),
    //     props: true,
    // },
    // {
    //     // 회원 탈퇴
    //     path: "/mypage/leave/:tab",
    //     component: () => import(/* webpackChunkName: "mypage" */ "../pages/client/mypage/leave.vue"),
    //     props: true,
    // },

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // 관리자 페이지 라우트
    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    {
        // 관리자 메인
        path: "/console",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Main.vue"),
        props: true,
        scope: ["console"],
    },
    {
        // 관리자 - 대시보드
        path: "/console/dashboard",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/Dashboard.vue"),
        props: true,
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardList.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardView.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/boards/:_board",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/board/BoardView.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/success",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/success/SuccessList.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/success/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/success/SuccessView.vue"),
    },
    {
        // 관리자 - 게시판관리
        path: "/console/success/:_success",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/success/SuccessView.vue"),
    },
    {
        // 관리자 - 변호사정보관리
        path: "/console/lawyers",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/lawyers/LawyerList.vue"),
    },
    {
        // 관리자 - 변호사정보관리
        path: "/console/lawyers/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/lawyers/LawyerView.vue"),
    },
    {
        // 관리자 - 변호사정보관리
        path: "/console/lawyers/:_lawyer",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/lawyers/LawyerView.vue"),
    },
    {
        // 관리자 - 언론&미디어
        path: "/console/insights",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/insights/InsightList.vue"),
    },
    {
        // 관리자 - 언론&미디어
        path: "/console/insights/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/insights/InsightView.vue"),
    },
    {
        // 관리자 - 언론&미디어
        path: "/console/insights/:_insight",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/insights/InsightView.vue"),
    },
    {
        // 관리자 - 폼메일관리
        path: "/console/forms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormList.vue"),
    },
    {
        // 관리자 - 폼메일관리
        path: "/console/forms/:_form",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/form/FormView.vue"),
    },
    {
        // 관리자 - 회원등급
        path: "/console/users/levels",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/LevelList.vue"),
        props: true,
    },
    {
        // 관리자 - 회원등급
        path: "/console/users/withdrawals",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/WithdrawalList.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자
        path: "/console/users",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserList.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자
        path: "/console/users/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserView.vue"),
        props: true,
    },
    {
        // 관리자 - 사용자
        path: "/console/users/:_user",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/user/UserView.vue"),
        props: true,
    },
    {
        // 관리자 - 공지사항
        path: "/console/center/notifications",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Notification.vue"),
        props: true,
    },
    {
        // 관리자 - FAQ
        path: "/console/center/faqs",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Faq.vue"),
        props: true,
    },
    {
        // 관리자 - 1:1문의
        path: "/console/center/questions",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/center/Question.vue"),
        props: true,
    },
    {
        // 관리자 - 서비스 이용약관
        path: "/console/terms",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/terms/TermsList.vue"),
        props: true,
    },
    {
        // 관리자 - 배너
        path: "/console/banners",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerList.vue"),
        props: true,
    },
    {
        // 관리자 - 배너
        path: "/console/banners/create",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerView.vue"),
        props: true,
    },
    {
        // 관리자 - 배너
        path: "/console/banners/:_banner",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/banner/BannerView.vue"),
        props: true,
    },
    {
        // 관리자 - 팝업
        path: "/console/popups",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/popup/PopupList.vue"),
        props: true,
    },
    {
        // 관리자 - 설정
        path: "/console/setting",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/SettingView.vue"),
        props: true,
    },
    {
        // 관리자 - 비밀번호
        path: "/console/password",
        component: () => import(/* webpackChunkName: "console-app" */ "../pages/console/setting/PasswordView.vue"),
        props: true,
    },
];

const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,

    scrollBehavior: (to, from, savedPosition) => {
        let scrollTo = undefined;

        if (to.hash) {
            scrollTo = to.hash;
        } else if (savedPosition) {
            scrollTo = savedPosition.y;
        }

        if (scrollTo != undefined)
            return {
                selector: scrollTo,
                behavior: "smooth",
            };
    },
});

router.beforeEach((to, from, next) => {
    try {
        const accessToken = sessionStorage.getItem("accessToken");
        axios.defaults.headers.common["Authorization"] = !!accessToken ? `Bearer ${accessToken}` : "";
        axios.defaults.headers.common["Accept-Language"] = i18n.locale;

        const route = routes.find((route) => route.path == to.path);
        if (!route?.scope) next();
        else {
            if (!accessToken) {
                if (0 <= to.path.indexOf("console")) {
                    next();
                    return;
                } else throw new Error("로그인 후 이용가능합니다");
            }

            const payload = JSON.parse(atob(accessToken.split(".")[1]));
            const scope = payload?.scope || [];

            if (!scope.find((scope) => route.scope.includes(scope))) {
                throw new Error("접근권한이 없습니다");
            }

            next();
        }
    } catch (error) {
        alert(error.message);
        window.location.href = routes.find((route) => route.path == from.path)?.path ?? routes.find((route) => route.path == "/")?.path ?? "about:blank";
    }
});

export default router;
